$(document).ready(function() {

    $( ".play-video" ).each(function() {
        $(this).on('click', function() {

          $(this).find("iframe")[0].src += "&autoplay=1&muted=1";
          $(this).addClass("active");

        });
    });

});


$('.click--down').click(function(){
    if ($(this).hasClass('down')) {
        $(this).parent().find(".accordion--slide").slideDown();
        $(this).addClass("up").removeClass("down");
    } else {
        $(this).parent().find(".accordion--slide").slideUp();
            $(this).addClass("down").removeClass("up");
    }
})



document.querySelectorAll('.download-link').forEach(link => {
    link.addEventListener('click', function(e) {
        e.preventDefault();
        const url = this.getAttribute('href');
        
        // Bereinige den Dateinamen von Sirv-Parametern
        let filename = url.split('/').pop(); // Extrahiere den Dateinamen aus der URL
        filename = filename.split('?')[0]; // Entferne Query-Parameter (z. B. _w=478&h=302)
        filename = filename.replace(/_w=\d+&h=\d+/, ''); // Entferne Sirv-spezifische Parameter wie _w=xxx&h=xxx
        if (!filename.match(/\.(jpg|jpeg|png|gif)$/i)) {
            // Füge eine Standard-Endung hinzu, falls keine Bildendung vorhanden ist
            filename = filename + '.jpg';
        }

        fetch(url, {
            method: 'GET',
            headers: {
                'Origin': window.location.origin
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Netzwerkfehler beim Abrufen des Bildes');
            }
            return response.blob();
        })
        .then(blob => {
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = filename; // Setze den bereinigten Dateinamen
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(blobUrl);
        })
        .catch(error => {
            console.error('Download fehlgeschlagen:', error);
            alert('Fehler beim Herunterladen des Bildes. Bitte versuche es erneut.');
        });
    });
});


document.querySelectorAll('.download-pdf').forEach(link => {
    link.addEventListener('click', function(e) {
        e.preventDefault();
        const url = this.getAttribute('href');
        
        // Bereinige den Dateinamen von Sirv-Parametern oder anderen Query-Parametern
        let filename = url.split('/').pop(); // Extrahiere den Dateinamen aus der URL
        filename = filename.split('?')[0]; // Entferne Query-Parameter
        filename = filename.replace(/_w=\d+&h=\d+|_[\w\d]+=\d+/, ''); // Entferne Sirv-spezifische Parameter
        if (!filename.match(/\.pdf$/i)) {
            // Füge .pdf-Endung hinzu, falls nicht vorhanden
            filename = filename + '.pdf';
        }

        fetch(url, {
            method: 'GET',
            headers: {
                'Origin': window.location.origin
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Netzwerkfehler beim Abrufen der PDF-Datei');
            }
            return response.blob();
        })
        .then(blob => {
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = filename; // Setze den bereinigten Dateinamen
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(blobUrl);
        })
        .catch(error => {
            console.error('Download fehlgeschlagen:', error);
            alert('Fehler beim Herunterladen der PDF-Datei. Bitte versuche es erneut.');
        });
    });
});